export const SALE_STATUS = {
  settled: "settled",
  scheduled: "scheduled",
  processing: "processing",
  failed: "failed",
  canceled: "canceled",
}

export const BLUETOOTH_CARD_READER_ID = "m2_bluetooth_card_reader"
